import { DEFAULT_LOCALE, LOCALES } from '@/i18n/routing';

function splitHref(href: string) {
  const markerIndex = href.search(/[?#]/);
  if (markerIndex === -1) {
    return { pathname: href, suffix: '' };
  }

  return {
    pathname: href.slice(0, markerIndex),
    suffix: href.slice(markerIndex),
  };
}

function isProtocolHref(href: string) {
  return /^[a-z][a-z0-9+.-]*:/i.test(href) || href.startsWith('//');
}

export function getSiteRuntimeLinkRel(external: boolean) {
  return external ? 'nofollow noopener noreferrer' : undefined;
}

export function localizeSiteRuntimeHref(params: {
  href: string;
  locale: string;
  external: boolean;
}) {
  if (
    params.external ||
    isProtocolHref(params.href) ||
    !params.href.startsWith('/')
  ) {
    return params.href;
  }

  const { pathname, suffix } = splitHref(params.href);
  const segments = pathname.split('/').filter(Boolean);
  const firstSegment = segments[0];
  const unprefixedSegments = LOCALES.includes(firstSegment)
    ? segments.slice(1)
    : segments;
  const unprefixedPath = `/${unprefixedSegments.join('/')}`.replace(/\/$/, '');
  const normalizedPath = unprefixedPath === '' ? '/' : unprefixedPath;

  if (params.locale === DEFAULT_LOCALE) {
    return `${normalizedPath}${suffix}`;
  }

  return `/${params.locale}${normalizedPath === '/' ? '' : normalizedPath}${suffix}`;
}
